import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";

import { SearchBarWithFilters } from "components/elements";
import {
  Filter,
  usePublicationsFilters,
  usePublicationHistoryFilters,
} from "hooks/tivoApps";
import { useFiltersSuggestions } from "pages/TiVoApps/_shared";
import { createLocationWithSearch } from "utils/url";

import { PATHS, TEXTS } from "../constants";
import { getPageMode } from "../utils";

export const PublicationsSearch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const mode = getPageMode();
  const { data: filters } = usePublicationsFilters();
  const { data: historyFilters } = usePublicationHistoryFilters();
  const { fetchSuggestions } = useFiltersSuggestions();

  const availableFilters = useMemo(() => {
    const sections: {
      title: string;
      options: Filter[];
    }[] = [];
    if (mode === PATHS.HISTORY) {
      sections.push({
        title: TEXTS.FILTERS_HISTORY,
        options: historyFilters?.results ?? [],
      });
    }
    sections.push({
      title: TEXTS.FILTERS,
      options: filters?.results ?? [],
    });
    return { sections };
  }, [filters?.results, historyFilters?.results, mode]);

  const handleSearch = useCallback(
    (search: Record<string, any>) =>
      navigate(createLocationWithSearch(location, search)),
    [location, navigate]
  );

  return (
    <SearchBarWithFilters
      filtersDataChoices={availableFilters}
      onSearch={handleSearch}
      suggestionApiEndpoint={fetchSuggestions}
    />
  );
};
